import React from "react";
import { colorForBase } from "../../lib/format";

export function CryptoLogo({ base, size = 24, color }) {
  const c = color || colorForBase(base);
  const letter = (base || "?").slice(0, 1);
  return (
    <div
      className="grid place-items-center rounded-full font-bold shrink-0"
      style={{
        width: size, height: size, fontSize: size * 0.42,
        background: `${c}1f`, color: c, border: `1px solid ${c}55`,
      }}
    >
      {base === "BTC" ? "\u20BF" : letter}
    </div>
  );
}

export function Sparkline({ data = [], color = "#22c55e", width = 96, height = 30 }) {
  if (!data || data.length < 2) return <svg width={width} height={height} />;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data.map((v, i) => `${(i * step).toFixed(1)},${(height - ((v - min) / range) * height).toFixed(1)}`);
  const up = data[data.length - 1] >= data[0];
  const stroke = color || (up ? "#22c55e" : "#ef4444");
  const id = `sp-${Math.random().toString(36).slice(2, 8)}`;
  return (
    <svg width={width} height={height}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stroke} stopOpacity="0.35" />
          <stop offset="100%" stopColor={stroke} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polyline points={`0,${height} ${points.join(" ")} ${width},${height}`} fill={`url(#${id})`} stroke="none" />
      <polyline points={points.join(" ")} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}
